<template>
  <div class="f-shop-detail-baseInfo tabs-item" id="baseInfo">
    <div class="title">基础信息</div>
    <el-row>
      <el-col :span="10">
        <el-row class="row">
          <el-col class="col-title" :span="5">店铺LOGO：</el-col>
          <el-col class="col-value" :span="19">
            <div class="logo-box">
              <el-image v-if="baseInfo.logo" :src="baseInfo.logo" class="img" fit="contain" />
            </div>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col class="col-title" :span="5">店铺名称：</el-col>
          <el-col class="col-value" :span="19">{{ baseInfo.name }}</el-col>
        </el-row>
        <el-row class="row">
          <el-col class="col-title" :span="5">商场：</el-col>
          <el-col class="col-value" :span="19">{{ baseInfo.mallName }}</el-col>
        </el-row>
        <el-row class="row">
          <el-col class="col-title" :span="5">外部店铺编号：</el-col>
          <el-col class="col-value" :span="19">{{ baseInfo.code }}</el-col>
        </el-row>
        <el-row class="row">
          <el-col class="col-title" :span="5">店铺楼层：</el-col>
          <el-col class="col-value" :span="19">
            <div class="tag-box">{{ baseInfo.floor }}</div>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col class="col-title" :span="5">所属业态：</el-col>
          <el-col class="col-value" :span="19" v-if="baseInfo.category">
            <div class="tag-box category" v-for="(item, index) in baseInfo.category.split(',')" :key="index">{{ item }}</div>
          </el-col>
        </el-row>
          <el-row class="row">
          <el-col class="col-title" :span="5">所属品牌：</el-col>
          <el-col class="col-value" :span="19">{{ baseInfo.brandName }}</el-col>
        </el-row>
        <el-row class="row">
          <el-col class="col-title" :span="5">店铺状态：</el-col>
          <el-col class="col-value" :span="19">{{ baseInfo.disable ? '关闭' : '开启' }}</el-col>
        </el-row>
        <el-row class="row">
          <el-col class="col-title" :span="5">店铺邮箱：</el-col>
          <el-col class="col-value" :span="19">{{ baseInfo.email }}</el-col>
        </el-row>
        <el-row class="row">
          <el-col class="col-title" :span="5">店铺简介：</el-col>
          <el-col class="col-value" :span="19">{{ baseInfo.introduction }}</el-col>
        </el-row>
        <el-row class="row">
          <el-col class="col-title" :span="6">店铺背景图：</el-col>
          <el-col class="col-value" :span="18">
            <div class="business-box" v-if="baseInfo.bgLogo">
              <el-image :src="baseInfo.bgLogo" class="img" fit="contain" />
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="12">
        <el-row class="row">
          <el-col class="col-title" :span="5">营业执照：</el-col>
          <el-col class="col-value" :span="19">
            <div class="business-box">
              <el-image v-if="baseInfo.businessLicenseUrl" :src="baseInfo.businessLicenseUrl" class="img" fit="contain" />
            </div>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col class="col-title" :span="5">结算账户类型：</el-col>
          <el-col class="col-value" :span="19">{{ baseInfo.accountType }}</el-col>
        </el-row>
        <el-row class="row">
          <el-col class="col-title" :span="5">主体名称：</el-col>
          <el-col class="col-value" :span="19">{{ baseInfo.financeName }}</el-col>
        </el-row>
        <el-row class="row">
          <el-col class="col-title" :span="5">银行名称：</el-col>
          <el-col class="col-value" :span="19">{{ baseInfo.bankName }}</el-col>
        </el-row>
        <el-row class="row">
          <el-col class="col-title" :span="5">银行账户：</el-col>
          <el-col class="col-value" :span="19">
            <span>{{ baseInfo.bankcardNo_show || baseInfo.bankcardNo }}</span>
            <auth-button auth="user:bankcard:read">
              <span class="look-phone-btn" @click="onLook('bankcardNo')" v-if="baseInfo.bankcardNo">
                {{baseInfo.bankcardNo_show ? '隐藏' : '查看'}}
              </span>
            </auth-button>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col class="col-title" :span="5">联行号：</el-col>
          <el-col class="col-value" :span="19">{{ baseInfo.unionBankNo }}</el-col>
        </el-row>
        <el-row class="row">
          <el-col class="col-title" :span="5">开户行：</el-col>
          <el-col class="col-value" :span="19">{{ baseInfo.openingbank }}</el-col>
        </el-row>
        <el-row class="row">
          <el-col class="col-title" :span="5">联营协议：</el-col>
          <el-col class="col-value" :span="19">
            <span class="download-btn" @click="onDownload">
              <span v-if="baseInfo.unionAgrementUrl">联营协议</span>
              <span v-if="baseInfo.unionAgrementUrl">.{{baseInfo.unionAgrementUrl.split('.')[baseInfo.unionAgrementUrl.split('.').length - 1]}}</span>
            </span>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col class="col-title" :span="5">联系电话：</el-col>
          <el-col class="col-value" :span="19">
            <span>{{ baseInfo.contractorPhone_show || baseInfo.contractorPhone }}</span>
            <auth-button auth="user:phone:read">
              <span class="look-phone-btn" @click="onLook('phone')" v-if="baseInfo.contractorPhone">
                {{baseInfo.contractorPhone_show ? '隐藏' : '查看'}}
              </span>
            </auth-button>
          </el-col>
        </el-row>
		
		<el-row class="row">
		  <el-col class="col-title" :span="5">统一社会信用代码：</el-col>
		  <el-col class="col-value" :span="19">{{ baseInfo.licenceNo }}</el-col>
		</el-row>
        <el-row class="row">
          <el-col class="col-title" :span="5">法人姓名：</el-col>
          <el-col class="col-value" :span="19">{{ baseInfo.corporateName }}</el-col>
        </el-row>
        <el-row class="row">
          <el-col class="col-title" :span="5">法人身份证号：</el-col>
          <el-col class="col-value" :span="19">{{ baseInfo.idCard }}</el-col>
        </el-row>
        <el-row class="row">
          <el-col class="col-title" :span="5">法人手机号：</el-col>
          <el-col class="col-value" :span="19">{{ baseInfo.phone }}</el-col>
        </el-row>
        <el-row class="row">
          <el-col class="col-title" :span="5">入网状态：</el-col>
          <el-col class="col-value" :span="19">{{ baseInfo.applicationStatus }}</el-col>
        </el-row>
		<el-row class="row">
		  <el-col class="col-title" :span="5">收款银行卡照片：</el-col>
		  <el-col class="col-value" :span="19">
		    <div class="business-box">
		      <el-image v-if="baseInfo.backCardUrl" :src="baseInfo.backCardUrl.indexOf('http')>=0 ? baseInfo.backCardUrl : ('https://runtu-pub.oss-cn-beijing.aliyuncs.com/' + baseInfo.backCardUrl)" class="img" fit="contain" />
		    </div>
		  </el-col>
		</el-row>
      </el-col>
    </el-row>
    <auth-button auth="finance:store:update">
      <el-button class="edit-btn" type="primary" @click="onEdit">编辑</el-button>
    </auth-button>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
export default {
  name: "fsDetailBaseInfo",
  components: {
    AuthButton
  },
  props: {
    baseInfo: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
    };
  },
  created() {
  },
  mounted() {
  },
  methods: {
    // 点击查看、隐藏手机号、银行账号按钮
    onLook(name) {
      this.$emit('onLook', name)
    },

    // 点击编辑按钮
    onEdit() {
      this.$router.push(`/financeShop/index/add?id=${this.$route.query.id}`)
    },

    // 点击下载联营协议
    onDownload() {
      let a = document.createElement('a')
      a.target = '_blank'
      a.download = '联营协议'
      a.href = this.baseInfo.unionAgrementUrl
      a.click()
    }
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.f-shop-detail-baseInfo {
  padding: 0 20px;
  padding-top: 20px;
  position: relative;
  margin-bottom: 20px;
  background-color: #fff;
  border-radius: 4px;

  .look-phone-btn {
    color: #3775FF;
    font-size: 10px;
    margin-left: 10px;

    &:hover {
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .download-btn {
    color: #3775FF;

    &:hover {
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .logo-box {
    width: 150px;
    height: 150px;
    border: 1px solid #ccc;
    border-radius: 2px;

    .img {
      width: 100%;
      height: 100%;
    }
  }

  .business-box {
    width: 250px;
    height: 150px;
    border: 1px solid #ccc;
    border-radius: 2px;

    .img {
      width: 100%;
      height: 100%;
    }
  }

  .row {
    min-height: 50px;
    line-height: 50px;
    font-size: 14px;
    color: #666666;

    .col-title {
      text-align: right;
    }

    .col-value {
      min-height: 50px;
      color: #333333;
      font-weight: 500;
    }
  }

  .tag-box {
    display: inline-block;
    height: 25px;
    line-height: 25px;
    padding: 0 18px;
    background: rgba(5,200,175,0.2);
    border: 1px solid #05C8AF;
    border-radius: 4px;
    color: #05C8AF;
    margin-right: 14px;

    &.category {
      position: relative;

      &::after {
        content: '';
        width: 10px;
        height: 1px;
        background-color: #05C8AF;
        position: absolute;
        right: -13px;
        top: 50%;
        transform: translateY(-50%);
      }

      &:last-child {
        &::after {
          display: none;
        }
      }
    }
  }

  .edit-btn {
    position: absolute;
    right: 20px;
    bottom: 25px;
  }

  .title {
    margin: 0;
    margin-bottom: 30px;
    margin-left: 20px;
    height: 25px;
    line-height: 25px;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    position: relative;

    &::before {
      position: absolute;
      top: 0;
      left: -15px;
      content: '';
      width: 5px;
      height: 25px;
      border-radius: 2px;
      background: #05C8AF;
    }
  }
}
</style>
